/**
 * @module lib/csv
 * @description RFC 4180 CSV serializer for flat records (pledge export).
 */
type Cell = string | number | boolean | null | undefined;

/** Quotes a cell when it contains a delimiter, quote or newline. */
const escapeCell = (value: Cell): string => {
    const s = value === null || value === undefined ? "" : String(value);
    return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

/** Serializes rows using the first row's keys as the header. */
export function toCsv(rows: ReadonlyArray<Record<string, Cell>>): string {
    if (rows.length === 0) return "";
    const headers = Object.keys(rows[0]);
    const lines = [headers.map(escapeCell).join(","), ...rows.map((r) => headers.map((h) => escapeCell(r[h])).join(","))];
    return lines.join("\r\n");
}
